import {importProvidersFrom, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {UpgradeModule} from '@angular/upgrade/static';
import {AppComponent} from './app.component';


import {HttpClientModule, provideHttpClient, withInterceptorsFromDi} from "@angular/common/http";
import {AccountCompromisedService} from "./services/accountCompromisedService";
import {ArchiveService} from "./services/archiveService";
import {AuthService} from "./services/authService";
import {QuickAccessService} from "./services/quickAccessService"
import {ClioService} from "./services/clioService";
import {ComposeMessageService} from "./services/composeMessageService";
import {DropboxService} from "./services/dropboxService";
import {GeneralService} from "./services/generalService";
import {myEmailsService} from "./services/myEmailsService";
import {RestangularConfigFactory, RouteService} from "./services/routeService";
import {NotificationService} from "./services/notificationService";
import {RestangularModule} from 'ngx-restangular';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {PartnerContactInfoComponent} from "./components/partners/partnerContactInfo/partner-contact-info.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {DropdownComponent} from './components/uiComponents/dropdown/dropdown.component';
import {PdfViewerModule} from 'ng2-pdf-viewer';
import {NgxDocViewerModule} from 'ngx-doc-viewer';
import {NgxUploaderModule} from 'ngx-uploader';
//import {TrustifiTableComponent} from './components/uiComponents/trustifi-table/trustifi-table.component';
import {BtnComponent} from './components/uiComponents/btn/btn.component';
import {LoaderComponent} from './components/uiComponents/loader/loader.component';
import {SearchEmailLoaderComponent} from './components/uiComponents/search-email-loader/search-email-loader.component';
import {SettingsListComponent} from './components/uiComponents/settings-layout/settings-list/settings-list.component';
import {
	SettingsListItemComponent
} from './components/uiComponents/settings-layout/settings-list-item/settings-list-item.component';
import {CheckboxComponent} from './components/uiComponents/checkbox/checkbox.component';
import {RadioBtnComponent} from './components/uiComponents/radio-btn/radio-btn.component';
//import {PopupFrameComponent} from './components/uiComponents/popup-frame/popup-frame.component';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import {PartnerRegistrationComponent} from "./components/partners/partnerRegistration/partner-registration.component";
import {PartnerResourcesComponent} from "./components/partners/partnerResources/partner-resources.component";
import {
	AmDateFormatPipe,
	CamelCasePipe,
	CamelCaseToTitleCasePipe,
	FormatBytes,
	GetTrackingEventPipe,
	LimitToPipe,
	NgForFilterPipe,
	OrderArrayBy,
	SafeHtml,
	SanitizeTextPipe,
	TitleizePipe,
	UniquePipe
} from './pipes';
import {NgApexchartsModule} from "ng-apexcharts";
import {PartnerUsageComponent} from "./components/partners/partnerUsage/partner-usage.component";
import {VirtualScrollerModule} from "ngx-virtual-scroller";
import {TrustifiTableComponent} from "./components/uiComponents/trustifi-table/trustifi-table.component";
import {PopupFrameComponent} from "./components/uiComponents/popup-frame/popup-frame.component";
import {ToggleSwitchComponent} from "./components/uiComponents/toggle-switch/toggle-switch.component";
import {SrRowActionComponent} from "./components/uiComponents/sr-row-action/sr-row-action.component";
import {
	AutoCompleteMenuComponent,
	AutoFocusDirective,
	ContentTooltipComponent,
	ContentTooltipDirective,
	DisableAutoCOmpleteDirective,
	DropdownPositionDirective,
	Explanation,
	ExplanationComponent,
	FocusMeDirective,
	HighlightTextDirective,
	inputNumberDirective,
	IsElps,
	MaskDirective,
	NgInit,
	ScrollToTopFlagDirective,
	SelectAllText,
	ShownDirective
} from './directives/directives';
import {ClickOutsideModule} from "ng-click-outside";
import {TooltipModule, TooltipOptions} from "ng2-tooltip-directive";
import {MyProfileComponent} from "./components/accountDetails/accountSettings/accountProfile/my-profile.component";
import {
	SharedPlanSettingsComponent
} from "./components/admin/outbound/planSettings/sharedPlan/shared-plan-settings.component";
import {ClipboardModule} from "ngx-clipboard";
import {IntegrationsComponent} from "./components/admin/planSettings/integrations/integrations.component";
import {
	ExchangeIntegrationComponent
} from "./components/admin/planSettings/integrations/exchange-integration/exchange-integration.component";
import {
	GsuiteIntegrationComponent
} from "./components/admin/planSettings/integrations/gsuite-integration/gsuite-integration.component";
import {
	PowershellIntegrationComponent
} from "./components/admin/planSettings/integrations/powershell-integration/powershell-integration.component";
import {
	LdapIntegrationComponent
} from "./components/admin/planSettings/integrations/ldap-integration/ldap-integration.component";
import {
	SecurityAwarenessComponent
} from "./components/admin/inbound/inboundShield/securityAwareness/security-awareness.component";
import {ScanThreatsComponent} from "./components/admin/inbound/inboundShield/scanThreats/scan-threats.component";
import {ngfModule} from "angular-file";
import {RegionComponent} from "./components/admin/planSettings/region/region.component";
import {AliasesPopupComponent} from "./directives/aliasesPopup/aliases-popup.component";
import {GroupsPopupComponent} from "./directives/groupsPopup/groups-popup.component";
import {
	AccountManagementComponent
} from "./components/accountCompromised/accountManagement/account-management.component";
import {AccountUserInfoComponent} from "./components/accountCompromised/accountManagement/account-user-info.component";
import {InboxComponent} from "./components/inbox/inbox.component";
import {LeafletComponent} from "./components/uiComponents/leaflet/leaflet.component";
import {FilterTableComponent} from "./directives/filterTable/filter-table.component";
import {
	AccountCompromisedConfigurationsComponent
} from "./components/accountCompromised/configurations/incidentsConfigurations/account-compromised-configurations.component";
import {
	AccountCompromisedReviewerConfigurationsComponent
} from './components/accountCompromised/configurations/reviewerConfigurations/account-compromised-reviewer-configurations.component';

import {
	AccountCompromisedAuditLogComponent
} from "./components/accountCompromised/accountCompromisedAuditLog/account-compromised-audit-log.component";
import {
	DomainProtectionAuditLogsComponent
} from "./components/admin/domainProtection/auditLog/domain-protection-audit-logs.component";
import {
	AccountDetailsNotificationsComponent
} from "./components/accountDetails/notifications/account-details-notifications.component";
import {ContactsComponent} from "./components/contactsAndTemplates/contacts/contacts.component";
import {
	InboundConfigurationComponent
} from "./components/admin/inbound/inboundShield/inboundConfiguration/inbound-configuration.componenet";
import {
	AccountCompromisedIncidentsComponent
} from "./components/accountCompromised/incidents/account-compromised-incidents.component";
import {SensitivityDetailsComponent} from "./directives/sensitivityDetails/sensitivity-details.component";
import {DiscoveredServicesComponent} from "./components/admin/inbound/discoveredServices/discovered-services.component";
import {AccountApiComponent} from "./components/accountDetails/accountSettings/accountApi/account-api.component";
import {AccountMcpComponent} from "./components/accountDetails/accountSettings/accountMcp/account-mcp.component";
import {
	AccountGraphqlComponent
} from "./components/accountDetails/accountSettings/accountGraphql/account-graphql.component";
import {
	AccountAddressesComponent
} from './components/accountDetails/accountSettings/accountAddresses/account-addresses.component';
import {PaypalButtonsComponent} from "./directives/payments/paypal-buttons.component";
import {StripeButtonsComponent} from "./directives/payments/stripe-buttons.component";
import {MyPlanComponent} from "./components/accountDetails/myPlan/my-plan.component";
import {
	AccountSecurityComponent
} from './components/accountDetails/accountSettings/accountSecurity/account-security.component';
import {ContactAddressBookComponent} from "./directives/contactAddressBook/contact-address-book.component";
import {ArchiveAuditLogComponent} from "./components/archive/archiveAuditLog/archive-audit-log.component";
import {ArchiveTrendsComponent} from "./components/archive/archiveTrends/archive-trends.component";
import {
	ArchiveCasesOperationsComponent
} from "./components/archive/archiveCasesOperations/archive-cases-operations.component";
import {AngularMyDatePickerModule} from 'angular-mydatepicker';
import {DatePickerComponent} from "./directives/datePicker";
import {CustomDatePickerComponent} from "./directives/custom-date-picker/custom-date-picker.component";
import {ArchiveCasesComponent} from "./components/archive/archiveCases/archive-cases.component";
import {ArchiveEmailDetailsComponent} from "./components/archive/archiveEmailDetails/archive-email-details.component";
import {
	ArchiveEmailTrackingComponent
} from "./components/archive/archiveEmailTracking/archive-email-tracking.component";
import {ArchiveEmailHeadersComponent} from './components/archive/archiveEmailHeaders/archive-email-headers.component';
import {
	ArchiveEmailQuarantinedComponent
} from "./components/archive/archiveEmailQuarantined/archive-email-quarantined.component";
import {ArchiveSearchComponent} from "./components/archive/archiveSearch/archive-search.component";
import {
	AccountIntegrationsComponent
} from "./components/accountDetails/accountSettings/accountIntegrations/account-integrations.component";
import {KnowledgeComponent} from "./components/knowledge/knowledge.component";
import {TrainingVideosComponent} from "./components/knowledge/training-videos.component";
import {MassListPageComponent} from "./components/contactsAndTemplates/massList/mass-list-page.component";
import {DomainSpoofingComponent} from "./components/admin/domainProtection/domainSpoofing/domain-spoofing.component";
import {TemplatesPageComponent} from "./components/contactsAndTemplates/templates/templates-page.component";
import {AttachmentsManagerComponent} from "./directives/attachmentsManager/attachments-manager.component";
import {UrlTrackingComponent} from "./components/admin/inbound/urlTracking/url-tracking.component";
import {previewLinkComponent} from "./directives/previewLink/preview-link.component";
import {MoreInfoComponent} from "./directives/moreInfoDrv";
import {AttachmentComponent} from "./directives/attachment-download/attachment-download.component";
import {DmarcReportsComponent} from "./components/admin/domainProtection/dmarcReports/dmarc-reports.component";
import {GenerateReportComponent} from "./components/admin/outbound/reports/generateReport/generate-report.component";
import {ScheduleReportComponent} from "./components/admin/outbound/reports/scheduleReport/schedule-report.component";
import {EmailTraceComponent} from "./components/admin/auditLog/emailTrace/email-trace.component";
import {ActivityLogsComponent} from "./components/admin/auditLog/activityLogs/activity-logs.component";
import {AdminAuditLogComponent} from "./components/admin/auditLog/adminAuditLog/admin-audit-log.component";
import {
	ThreatResponseComponent
} from "./components/admin/inbound/threatResponse/threatResponse/threat-response.component";
import {ApplyPolicyComponent} from "./components/applyPolicy/apply-policy.component";
import {
	OutboundQuarantinedComponent
} from "./components/admin/outbound/outboundQuarantined/outbound-quarantined.component";
import {PlanSettingsDomainComponent} from "./components/admin/planSettings/domains/plan-settings-domain.component";
import {OnboardingDomainsComponent} from "./components/onboarding/onboarding-domains/onboarding-domains.component";
import {
	OnboardingMailboxesComponent
} from "./components/onboarding/onboarding-mailboxes/onboarding-mailboxes.component";
import {
	OnboardingConnectApiIntegrationComponent
} from "./components/onboarding/onboarding-connect-api-integration/onboarding-connect-api-integration.component";
import {
	OnboardingPowershellIntegrationComponent
} from "./components/onboarding/onboarding-powershell-integration/onboarding-powershell-integration.component";
import {
	OnboardingCopyPolicyComponent
} from "./components/onboarding/onboarding-copy-policy/onboarding-copy-policy.component";
import {
	OnboardingOutboundMtaComponent
} from "./components/onboarding/onboarding-outbound-mta/onboarding-outbound-mta.component";
import {
	OnboardingReviewersComponent
} from "./components/onboarding/onboarding-reviewers/onboarding-reviewers.component";
import {
	EmailRelayIntegrationComponent
} from "./components/admin/outbound/planSettings/outboundEmailRelay/email-relay-integration.component";
import {ExchangeRulesWizardComponent} from "./directives/exchangeRulesWizardDrv/exchange-rules-wizard.component";
import {
	ExchangeProtectionWizardComponent
} from "./directives/exchangeProtectionWizardDrv/exchange-protection-wizard.component";
import {
	ExchangeUpdateRulesWizardComponent
} from "./directives/exchangeUpdateRulesWizardDrv/exchange-update-rules-wizard.component";
import {ViewExchangeCfgWizardComponent} from "./directives/viewExchangeCfgWizardDrv/view-exchange-cfg-wizard.component";
import {ExchangeLoginWizardComponent} from "./directives/exchangeLoginWizardDrv/exchange-login-wizard.component";
import {
	ExchangeQuarantinedEmailsWizardComponent
} from "./directives/exchangeQuarantinedEmailsWizardDrv/exchange-quarantined-emails-wizard.component";
import {
	InboundEmailRelayIntegrationComponent
} from "./components/admin/inbound/planSettings/inboundEmailRelay/inbound-email-relay-integration.component";
import {
	SelectiveMailboxProtectionComponent
} from "./components/admin/inbound/planSettings/inboundEmailRelay/selectiveMailboxProtection/selective-mailbox-protection.component";
import {LookAndFeelComponent} from "./components/admin/outbound/lookAndFeel/look-and-feel.component";
import {ColorPickerModule} from "ngx-color-picker";
import {
	ThreatPreventionComponent
} from "./components/admin/inbound/inboundShield/threatPrevention/threat-prevention.component";
import {
	NotificationOptionsComponent
} from "./components/admin/inbound/inboundShield/threatPrevention/notification-options/notification-options.component";
import {NgxSummernoteModule} from 'ngx-summernote';
import {
	OutboundReviewersComponent
} from './components/admin/outbound/rulesAndPolicies/outbound-reviewers/outbound-reviewers.component';
import {
	AccountCompromisedTrendsComponent
} from "./components/accountCompromised/accountCompromisedTrends/account-compromised-trends.component";
import {
	OutboundPoliciesComponent
} from "./components/admin/outbound/rulesAndPolicies/policies/outbound-policies.component";

import {InboundTrendsComponent} from "./components/admin/inbound/trends/inbound-trends.component";
import {
	PeriodComparisonPickerComponent
} from "./components/uiComponents/period-comparison-picker/period-comparison-picker.component";
import {TrendsComparisonDirective} from "./directives/trendsComparison/trends-comparison.directive";
import {OutboundTrendsComponent} from "./components/admin/outbound/outboundTrends/outbound-trends.component";
import {OutboundRuleUsageComponent} from "./directives/outbound-rule-usage/outbound-rule-usage.component";
import {
	CollaborationRuleUsageComponent
} from "./directives/collaboration-rule-usage/collaboration-rule-usage.component";
import {HomeComponent} from "./components/home/home.component";
import {OutboundRulesComponent} from "./components/admin/outbound/rulesAndPolicies/rules/outbound-rules.component";
import {
	OutboundEmailSignaturesComponent
} from "./components/admin/outbound/rulesAndPolicies/emailSignatures/outbound-email-signatures.component";
import {SensitivityTypeComponent} from "./directives/sensitivityTypeDrv/sensitivity-type.component";
import {
	NewRuleConditionComponent
} from "./components/admin/outbound/rulesAndPolicies/rules/new-rule-condition.component";
import {UserInboundConfComponent} from "./components/admin/inbound/userInboundConf/user-inbound-conf.component";
import {UserQuarantinedComponent} from './components/admin/inbound/userQuarantined/user-quarantined.component';
import {InboundMailboxesComponent} from "./components/admin/inbound/mailboxes/inbound-mailboxes.component";
import {
	InboundAllowBlockListsComponent
} from "./components/admin/inbound/configuration/allowBlockLists/inbound-allow-block-lists.component";
import {
	InboundBlockFileTypesComponent
} from "./components/admin/inbound/configuration/blockFileTypes/inbound-block-file-types.component";
import {
	InboundEmailRulesComponent
} from "./components/admin/inbound/inboundShield/inboundEmailRules/inbound-email-rules.component";
import {
	InboundNewRuleConditionComponent
} from "./components/admin/inbound/inboundShield/inboundEmailRules/inbound-new-rule-condition.component";
import {OnboardingWizardComponent} from "./components/onboarding/onboarding-wizard.component";
import {LoginComponent} from "./components/login/login.component";
import {PasswordLoginComponent} from "./components/login/password-login.component";
import {EmailAndSsoComponent} from "./components/login/email-and-sso.component";
import {SignupFormComponent} from "./components/signup/signup-form/signup-form.component";
import {MfaComponent} from "./components/login/mfa.component";
import {PinCodeComponent} from "./directives/pin-code/pin-code.component";
import {InboundQuarantinedComponent,} from "./components/admin/inbound/quarantined/inbound-quarantined.component";
import {QuarantinedEmailActionComponent} from "./components/quarantinedEmailActions/quarantined-email-action.component";
import {AttachmentsComponent} from "./components/attachments/attachments.component";
import {InboundTrendsService} from "./services/inboundTrendsService";
import {SentEmailsComponent} from "./components/sentEmails/sent-emails.component";
import {NotificationToasterComponent} from "./directives/notificationToaster/notification-toaster.component";
import {SentEmailTrackingComponent} from "./components/sentEmails/sentEmailTracking/sent-email-tracking.component";
import {SentEmailDetailsComponent} from "./components/sentEmails/sentEmailDetails/sent-email-details.component";
import {SentEmailSummaryComponent} from "./components/sentEmails/sentEmailSummary/sent-email-summary.component";
import {SentEmailAdvancedComponent} from "./components/sentEmails/sentEmailAdvanced/sent-email-advanced.component";
import {SentEmailPostmarkComponent} from "./components/sentEmails/sentEmailPostmark/sent-email-postmark.component";
import {PopupDrvComponent} from "./directives/popup-drv-component/popup-drv.component";
import {
	ThreatSimulationCampaignWizardComponent
} from "./components/threatSimulation/threatSimulationCampaigns/newCampaignWizard/threat-simulation-campaign-wizard.component";
import {UserManagementComponent} from "./components/admin/outbound/userManagement/user-management.component";
import {
	NewPlanWizardComponent
} from "./components/admin/outbound/userManagement/newPlanWizard/new-plan-wizard.component";
import {UserPermissionsComponent} from "./components/admin/outbound/userPermissions/user-permissions.component";
import {
	UserPermissionsTabsComponent
} from "./components/admin/outbound/userPermissions/user-permissions-tabs.component";
import {
	UserPermissionsMultiTenantComponent
} from "./components/admin/outbound/userPermissions/user-permissions-multi-tenant.component";
import {
	ThreatSimulationCampaignDetailsComponent
} from "./components/threatSimulation/threatSimulationCampaigns/campaignDetails/threat-simulation-campaign-details.component";
import {ComposeMessageComponent} from "./components/composeMessage/compose-message.component";
import {
	ThreatSimulationAuditLogsComponent
} from "./components/threatSimulation/threatSimulationAuditLogs/threat-simulation-audit-logs.component";
import {
	ThreatSimulationCampaignsComponent
} from "./components/threatSimulation/threatSimulationCampaigns/threat-simulation-campaigns.component";
import {
	ThreatSimulationNotSupportedComponent
} from "./components/threatSimulation/threatSimulationCampaigns/not-supported.component";
import {
	ThreatSimulationConfigComponent
} from "./components/threatSimulation/threatSimulationConfig/configuration/threat-simulation-config.component";
import {
	ThreatSimulationCampaignSummaryComponent
} from "./components/threatSimulation/threatSimulationCampaigns/campaignSummary/threat-simulation-campaign-summary.component";
// CC: taken from app.module.ts -> ThreatSimulationCampaignSummaryComponent import
import {
	ThreatSimulationCampaignRecipientsSummaryComponent
} from "./components/threatSimulation/threatSimulationCampaigns/campaignRecipientsSummary/threat-simulation-campaign-recipients-summary.component";
import {
	ThreatSimulationTemplatesComponent
} from "./components/threatSimulation/threatSimulationTemplates/threat-simulation-templates.component";
import {
	ThreatSimulationTrendsComponent
} from "./components/threatSimulation/ThreatSimulationTrends/threat-simulation-trends.component";
import {
	ThreatSimulationReviewersComponent
} from "./components/threatSimulation/threatSimulationConfig/reviewers/threat-simulation-reviewers.component";
import {
	ThreatSimulationTemplateFieldsComponent
} from './components/threatSimulation/threatSimulationConfig/threat-simulation-template-fields/threat-simulation-template-fields.component';
import {
	AccountCompromisedUserIncidentsInfoComponent
} from "./components/accountCompromised/accountCompromisedUserIncidentsInfo/user-incidents-info.component";
import {SignupComponent} from "./components/signup/signup.component";
import {PurchasePageComponent} from "./components/signup/purchase/purchase-page.component";
import {McpAuthorizeComponent} from "./components/mcpAuthorize/mcp-authorize.component";
import {SupportMenuComponent} from "./components/support/support-menu.component";
import {
	accountCompromisedCfgTabsComponent
} from "./components/accountCompromised/configurations/account-compromised-configurations-tabs.component";
import {TabsPageContainer} from "./components/uiComponents/tabsPageContainer";
import {OutboundPlanTabsComponent} from "./components/admin/outbound/planSettings/outbound-plan-tabs.component";
import {EmailFlowTabsComponent} from "./components/admin/adminCenter/emailFlow/email-flow-tabs.component";
import {EmailFlowViewComponent} from "./components/admin/adminCenter/emailFlow/email-flow-view.component";
import {FlowDiagramComponent} from "./components/admin/adminCenter/emailFlow/flow-diagram.component";
import {MyAccountTabsComponent} from "./components/accountDetails/accountSettings/myAccount/my-account-tabs.component";
import {OutboundReportTabsComponent} from "./components/admin/outbound/reports/outbound-report-tabs.component";
import {
	RulesAndPoliciesTabsComponent
} from "./components/admin/outbound/rulesAndPolicies/rules-and-policies-tabs.component";
import {
	InboundConfigurationTabsComponent
} from "./components/admin/inbound/configuration/inbound-configuration-tabs.component";
import {InboundShieldTabsComponent} from "./components/admin/inbound/inboundShield/inbound-shield-tabs.component";
import {
	ThreatSimulationsConfigTabsComponent
} from "./components/threatSimulation/threatSimulationConfig/threat-simulation-cfg-tabs.component";
import {
	InboundPlanSettingsTabsComponent
} from "./components/admin/inbound/planSettings/plan/inbound-plan-settings-tabs.component";
import {ContentComponent} from "./components/content/content.component";
import {AppRoutingModule, DummyComponent} from "./app-routing.module";
import {CloudspongeComponent} from "./directives/cloudspongeComponent";
import {NgProgressHttpModule} from "ngx-progressbar/http";
import {NgProgressModule} from "ngx-progressbar";
import {AttachmentPreviewComponent} from './components/attachments/attachment-preview/attachment-preview.component';
import {
	AuditLogScheduleReportComponent
} from "./components/audit-log-schedule-report/audit-log-schedule-report.component";
import {ReviewersComponent} from "./components/admin/inbound/inboundShield/reviewers/reviewers.component";
import {UsersSelectionComponent} from "./directives/users-selection/users-selection.component";
import {LookAndFeelService} from "./services/lookAndFeelService";
import {CountryCodeSelectComponent} from "./components/uiComponents/country-code-select/country-code-select.component";
import {SearchBoxComponent} from "./components/uiComponents/search-box/search-box.component";
import {TrackingComponent} from "./components/uiComponents/tracking/tracking.component";
import {DataClassificationTabs} from "./components/admin/outbound/dataClassification/data-classification-tabs";
import {
	OutboundSensitivityTypesComponent
} from "./components/admin/outbound/dataClassification/sensitivityTypes/outbound-sensitivity-types.component";
import {
	OutboundPersonalTypesComponent
} from "./components/admin/outbound/dataClassification/personalTypes/outbound-personal-types.component";
import {
	OutboundTestSensitivityComponent
} from "./components/admin/outbound/dataClassification/testSensitivity/outbound-test-sensitivity.component";
import {
	ClassificationTrendsComponent
} from './components/admin/outbound/dataClassification/classification-trends/classification-trends.component';
import {
	DomainImpersonationComponent
} from './components/admin/domainProtection/domain-impersonation/domain-impersonation.component';
import {UserPermissionService} from "./services/userPermissionService";
import {EmailViewerComponent} from "./components/uiComponents/email-viewer.component";
import {
	ThreatSimulationCampaignConfigurationComponent
} from "./components/threatSimulation/threatSimulationCampaigns/campaignConfiguration/threat-simulation-campaign-configuration.component";
import {EchartsGraphComponent} from "./components/uiComponents/echartsGraph/echarts-graph.component";
import {
	ArchiveConfigurationsGeneralComponent
} from "./components/archive/archiveConfigurations/archiveGeneral/archive-configurations-general.component";
import {
	ArchiveMigrationComponent
} from "./components/archive/archiveConfigurations/archiveMigration/archive-migration.component";
import {
	ArchiveReviewersComponent
} from "./components/archive/archiveConfigurations/archive-reviewers/archive-reviewers.component";
import {
	ArchiveConfigurationTabsComponent
} from "./components/archive/archiveConfigurations/archive-configuration-tabs.component";
import {
	ThreatSimulationTrainingMaterialsComponent
} from "./components/threatSimulation/threatSimulationTrainingMaterials/threat-simulation-training-materials.component";
import {
	ThreatSimulationCampaignsTabsComponent
} from "./components/threatSimulation/threatSimulationCampaigns/threat-simulation-campaigns-tabs.component";
import {
	AccountCompromisedConfigurationWizardComponent
} from "./components/accountCompromised/configurations/configurationWizard/account-compromised-configuration-wizard.component";
import {SearchInPageComponent} from "./directives/searchInPage/search-in-page.component";
import {SupportTicketsComponent} from "./components/support/supportTickets/support-tickets.component";
import {
	TableQueryTemplatesDropdownComponent
} from "./components/uiComponents/tableQueryTemplates/tableQueryTemplatesDropdown/table-query-templates-dropdown";
import {TableQueryTemplatesService} from "./services/tableQueryTemplatesService";
import {
	TableQueryTemplatesControlsComponent
} from "./components/uiComponents/tableQueryTemplates/tableQueryTemplatesControls/table-query-templates-controls";
import {ExchangeJunkRuleWizardComponent} from "./directives/exchangeJunkRuleDrv/exchange-junk-rule-wizard.component";
import {
	ThreatSimulationQuizComponent
} from "./components/threatSimulation/threatSimulationTrainingMaterials/ThreatSimulationMaterialQuiz/threat-simulation-quiz.component";
import {
	ThreatSimulationQuizCreationWizardComponent
} from "./components/threatSimulation/threatSimulationTrainingMaterials/quizCreationWizard/threat-simulation-quiz-creation-wizard.component";
import {
	ThreatRetrospectComponent
} from "./components/admin/inbound/threatResponse/threatRetrospect/threat-retrospect.component";
import {ThreatResponseTabsComponent} from "./components/admin/inbound/threatResponse/threat-response-tabs.component";
import {ToolsTabsComponent} from "./components/support/tools/tools-tabs.component";
import {UrlDefangerToolComponent} from "./components/support/tools/urlDefanger/url-defanger-tool.component";
import {EmailAnalyzerToolComponent} from "./components/support/tools/emailAnalyzer/email-analyzer-tool.component";
import {MxResolverToolComponent} from "./components/support/tools/mxResolver/mx-resolver-tool.component";
import {
	SpfRecordCheckerToolComponent
} from "./components/support/tools/spfRecordChecker/spf-record-checker-tool.component";
import {UrlDecoderToolComponent} from "./components/support/tools/urlDecoder/url-decoder-tool.component";
import {HlsPlayerComponent} from "./components/uiComponents/hls-stream-video-player";
import {SubtitlesDirective, VideoSubtitleControlsComponent} from "./directives/subtitles.directive";
import {
	AccountCompromisedRulesConfigurationsComponent
} from "./components/accountCompromised/configurations/rulesConfigurations/account-compromised-rules-configurations.component";
import {
	AccountCompromisedRulesConditionComponent
} from "./components/accountCompromised/configurations/rulesConfigurations/account-compromised-new-rule-condition.component";
import {AiAssistantChatComponent} from "./components/aiAssistant/ai-assistant-chat.component";
import {
	CollaborationProtectionAuditLogsComponent
} from './components/admin/collaborationProtection/collaboration-protection-audit-logs/collaboration-protection-audit-logs.component';
import {
	CollaborationProtectionUsersComponent
} from './components/admin/collaborationProtection/collaboration-protection-users/collaboration-protection-users.component';
import {
	CollaborationProtectionConfigurationComponent
} from './components/admin/collaborationProtection/collaboration-protection-configuration/collaboration-protection-configuration.component';
import {
	CollaborationNotSupportedComponent
} from './components/admin/collaborationProtection/collaboration-not-supported/collaboration-not-supported.component';
import {
	CollaborationProtectionReviewersComponent
} from './components/admin/collaborationProtection/collaboration-protection-reviewers/collaboration-protection-reviewers.component';
import {
	CollaborationProtectionTabsComponent
} from './components/admin/collaborationProtection/collaboration-protection-tabs.component';
import {
	CollaborationResourcesComponent
} from './components/admin/collaborationProtection/collaboration-resources/collaboration-resources.component';
import {
	InboundScanMetricsComponent
} from './components/admin/inbound/inboundShield/inbound-scan-metrics/inbound-scan-metrics.component';
import {
	CollaborationMappingComponent
} from './components/admin/collaborationProtection/collaboration-mapping/collaboration-mapping.component';
import {
	CollaborationOverviewComponent
} from './components/admin/collaborationProtection/collaboration-overview/collaboration-overview.component';
import {
	CollaborationProtectionPoliciesComponent
} from './components/admin/collaborationProtection/collaboration-protection-policies/collaboration-protection-policies.component';
import {
	CollaborationUsersResourcesTabsComponent
} from './components/admin/collaborationProtection/collaboration-users-resources-tabs/collaboration-users-resources-tabs.component';
import {
	CollaborationThreatEventsComponent
} from './components/admin/collaborationProtection/collaboration-threat-events/collaboration-threat-events.component';
import {
	CollaborationAssetsComponent
} from './components/admin/collaborationProtection/collaboration-assets/collaboration-assets.component';
import {
	CollaborationAssetInfoComponent
} from "./components/admin/collaborationProtection/assetInfo/collaboration-asset-info.component";
import {
	CollaborationResourceInfoComponent
} from "./components/admin/collaborationProtection/resourceInfo/collaboration-resource-info.component";

import {
	CollaborationProtectionRulesComponent
} from './components/admin/collaborationProtection/collaborationProtectionRules/collaboration-protection-rules.component';
import {
	CollaborationProtectionNewRuleConditionComponent
} from "./components/admin/collaborationProtection/collaborationProtectionRules/collaboration-protection-new-rule-condition.component";
import {MultiTenantSelectionComponent} from "./components/multiTenantSelection/multi-tenant-selection.component";
import {
	TrendsComparisonCardDirective
} from "./directives/trendsComparison/trendsComparisonCard/trends-comparison-card.directive";
import {
	TrendsComparisonChartComponent
} from "./directives/trendsComparison/trendsComparisonChart/trends-comparison-chart.component";
import {RadialbarHalfLabelsDirective} from "./directives/radialbarHalfLabels/radialbar-half-labels.directive";

const defaultTooltipOptions: TooltipOptions = {
	'hide-delay': 0,
	animationDuration: 150,
	tooltipClass: 'tooltip-drv'
};

@NgModule({
	declarations: [
		AppComponent,
		ContentComponent,
		PopupDrvComponent,
		TabsPageContainer,
		HomeComponent,
		LoginComponent,
		PasswordLoginComponent,
		UsersSelectionComponent,
		SignupFormComponent,
		MfaComponent,
		PinCodeComponent,
		NotificationToasterComponent,
		SupportMenuComponent,
		SupportTicketsComponent,
		ToolsTabsComponent,
		EmailAnalyzerToolComponent,
		UrlDefangerToolComponent,
		MxResolverToolComponent,
		SpfRecordCheckerToolComponent,
		UrlDecoderToolComponent,
		EmailAndSsoComponent,
		ReviewersComponent,
		PartnerContactInfoComponent,
		PartnerRegistrationComponent,
		PartnerResourcesComponent,
		GenerateReportComponent,
		OutboundQuarantinedComponent,
		PartnerUsageComponent,
		DummyComponent,
		InboundBlockFileTypesComponent,
		InboundConfigurationTabsComponent,
		InboundEmailRulesComponent,
		InboundShieldTabsComponent,
		OutboundReportTabsComponent,
		DataClassificationTabs,
		OutboundSensitivityTypesComponent,
		OutboundPersonalTypesComponent,
		OutboundTestSensitivityComponent,
		ScheduleReportComponent,
		InboundMailboxesComponent,
		UserManagementComponent,
		NewPlanWizardComponent,
		UserPermissionsComponent,
		UserPermissionsTabsComponent,
		UserPermissionsMultiTenantComponent,
		SentEmailsComponent,
		SentEmailDetailsComponent,
		SentEmailTrackingComponent,
		TrackingComponent,
		SentEmailSummaryComponent,
		SentEmailAdvancedComponent,
		SentEmailPostmarkComponent,
		AttachmentsComponent,
		InboundAllowBlockListsComponent,
		InboundNewRuleConditionComponent,
		AccountCompromisedTrendsComponent,
		DropdownComponent,
		InboundQuarantinedComponent,
		QuarantinedEmailActionComponent,
		UrlTrackingComponent,
		MyProfileComponent,
		OutboundPoliciesComponent,
		OutboundEmailSignaturesComponent,
		RulesAndPoliciesTabsComponent,
		InboundPlanSettingsTabsComponent,
		InboundEmailRelayIntegrationComponent,
		SelectiveMailboxProtectionComponent,
		UserInboundConfComponent,
		AuditLogScheduleReportComponent,
		UserQuarantinedComponent,
		ContentTooltipComponent,
		AutoCompleteMenuComponent,
		HlsPlayerComponent,
		SubtitlesDirective,
		VideoSubtitleControlsComponent,
		inputNumberDirective,
		DropdownPositionDirective,
		DisableAutoCOmpleteDirective,
		AccountIntegrationsComponent,
		SharedPlanSettingsComponent,
		ActivityLogsComponent,
		AdminAuditLogComponent,
		EmailRelayIntegrationComponent,
		OutboundPlanTabsComponent,
		EmailFlowTabsComponent,
		EmailFlowViewComponent,
		FlowDiagramComponent,
		ThreatResponseComponent,
		ThreatRetrospectComponent,
		ThreatResponseTabsComponent,
		ApplyPolicyComponent,
		EmailTraceComponent,
		AccountApiComponent,
		AccountMcpComponent,
		AccountGraphqlComponent,
		LookAndFeelComponent,
		InboundTrendsComponent,
		PeriodComparisonPickerComponent,
		TrendsComparisonDirective,
		TrendsComparisonCardDirective,
		TrendsComparisonChartComponent,
		RadialbarHalfLabelsDirective,
		ThreatPreventionComponent,
		NotificationOptionsComponent,
		ExchangeRulesWizardComponent,
		ExchangeJunkRuleWizardComponent,
		ExchangeProtectionWizardComponent,
		OutboundRulesComponent,
		ExchangeUpdateRulesWizardComponent,
		ViewExchangeCfgWizardComponent,
		ExchangeLoginWizardComponent,
		ExchangeQuarantinedEmailsWizardComponent,
		PlanSettingsDomainComponent,
		OnboardingDomainsComponent,
		OnboardingMailboxesComponent,
		OnboardingConnectApiIntegrationComponent,
		OnboardingPowershellIntegrationComponent,
		OnboardingCopyPolicyComponent,
		OnboardingOutboundMtaComponent,
		OnboardingReviewersComponent,
		SecurityAwarenessComponent,
		DomainProtectionAuditLogsComponent,
		AccountDetailsNotificationsComponent,
		ScanThreatsComponent,
		OutboundTrendsComponent,
		SensitivityTypeComponent,
		NewRuleConditionComponent,
		OutboundRuleUsageComponent,
		CollaborationRuleUsageComponent,
		ArchiveCasesComponent,
		ArchiveEmailHeadersComponent,
		ArchiveEmailTrackingComponent,
		ArchiveEmailQuarantinedComponent,
		AccountAddressesComponent,
		DomainSpoofingComponent,
		KnowledgeComponent,
		TrainingVideosComponent,
		DmarcReportsComponent,
		AccountSecurityComponent,
		MyAccountTabsComponent,
		InboundConfigurationComponent,
		RegionComponent,
		IntegrationsComponent,
		ExchangeIntegrationComponent,
		GsuiteIntegrationComponent,
		PowershellIntegrationComponent,
		LdapIntegrationComponent,
		ContactsComponent,
		EchartsGraphComponent,
		BtnComponent,
		InboxComponent,
		AccountManagementComponent,
		AccountUserInfoComponent,
		AccountCompromisedConfigurationsComponent,
		AccountCompromisedReviewerConfigurationsComponent,
		AccountCompromisedRulesConfigurationsComponent,
		AccountCompromisedRulesConditionComponent,
		AccountCompromisedAuditLogComponent,
		AccountCompromisedConfigurationWizardComponent,
		LoaderComponent,
		SearchEmailLoaderComponent,
		AliasesPopupComponent,
		GroupsPopupComponent,
		FormatBytes,
		SafeHtml,
		OrderArrayBy,
		CamelCasePipe,
		CamelCaseToTitleCasePipe,
		NgForFilterPipe,
		AmDateFormatPipe,
		LimitToPipe,
		UniquePipe,
		TitleizePipe,
		SanitizeTextPipe,
		GetTrackingEventPipe,
		SearchInPageComponent,
		SettingsListComponent,
		SettingsListItemComponent,
		CheckboxComponent,
		RadioBtnComponent,
		SearchBoxComponent,
		TrustifiTableComponent,
		PopupFrameComponent,
		ToggleSwitchComponent,
		SrRowActionComponent,
		ArchiveAuditLogComponent,
		ArchiveTrendsComponent,
		ArchiveConfigurationTabsComponent,
		ArchiveConfigurationsGeneralComponent,
		ArchiveMigrationComponent,
		ArchiveReviewersComponent,
		AutoFocusDirective,
		AiAssistantChatComponent,
		SelectAllText,
		Explanation,
		IsElps,
		HighlightTextDirective,
		FocusMeDirective,
		ContentTooltipDirective,
		NgInit,
		MaskDirective,
		ShownDirective,
		ScrollToTopFlagDirective,
		DropdownComponent,
		LeafletComponent,
		FilterTableComponent,
		TableQueryTemplatesDropdownComponent,
		TableQueryTemplatesControlsComponent,
		ExplanationComponent,
		ExplanationComponent,
		DiscoveredServicesComponent,
		AccountCompromisedIncidentsComponent,
		AccountCompromisedUserIncidentsInfoComponent,
		accountCompromisedCfgTabsComponent,
		SensitivityDetailsComponent,
		DiscoveredServicesComponent,
		MyPlanComponent,
		PaypalButtonsComponent,
		StripeButtonsComponent,
		DiscoveredServicesComponent,
		ArchiveCasesOperationsComponent,
		DatePickerComponent,
		CustomDatePickerComponent,
		ArchiveSearchComponent,
		ArchiveEmailDetailsComponent,
		MassListPageComponent,
		TemplatesPageComponent,
		AttachmentsManagerComponent,
		MassListPageComponent,
		ContactAddressBookComponent,
		previewLinkComponent,
		MoreInfoComponent,
		AttachmentComponent,
		OnboardingWizardComponent,
		OutboundReviewersComponent,
		ThreatSimulationTemplatesComponent,
		ThreatSimulationCampaignsComponent,
		ThreatSimulationCampaignsTabsComponent,
		ThreatSimulationAuditLogsComponent,
		ThreatSimulationCampaignWizardComponent,
		ThreatSimulationCampaignDetailsComponent,
		ThreatSimulationNotSupportedComponent,
		ThreatSimulationCampaignConfigurationComponent,
		ThreatSimulationCampaignSummaryComponent,
		ThreatSimulationCampaignRecipientsSummaryComponent,
		ThreatSimulationConfigComponent,
		ThreatSimulationsConfigTabsComponent,
		ThreatSimulationReviewersComponent,
		ThreatSimulationTrendsComponent,
		ThreatSimulationTemplateFieldsComponent,
		ThreatSimulationTrainingMaterialsComponent,
		ThreatSimulationQuizComponent,
		ThreatSimulationQuizCreationWizardComponent,
		ComposeMessageComponent,
		SignupComponent,
		PurchasePageComponent,
		McpAuthorizeComponent,
		CloudspongeComponent,
		AttachmentPreviewComponent,
		CountryCodeSelectComponent,
		ClassificationTrendsComponent,
		DomainImpersonationComponent,
		EmailViewerComponent,
		ArchiveReviewersComponent,
		CollaborationProtectionAuditLogsComponent,
		CollaborationProtectionUsersComponent,
		CollaborationProtectionConfigurationComponent,
		CollaborationNotSupportedComponent,
		CollaborationProtectionReviewersComponent,
		CollaborationProtectionTabsComponent,
		CollaborationResourcesComponent,
		InboundScanMetricsComponent,
		CollaborationMappingComponent,
		CollaborationOverviewComponent,
		CollaborationProtectionPoliciesComponent,
		CollaborationUsersResourcesTabsComponent,
		CollaborationThreatEventsComponent,
		CollaborationAssetsComponent,
		CollaborationAssetInfoComponent,
		CollaborationResourceInfoComponent,
		CollaborationProtectionRulesComponent,
		CollaborationProtectionNewRuleConditionComponent,
		MultiTenantSelectionComponent,
	],
	imports: [
		BrowserModule,
		FormsModule,
		ReactiveFormsModule,
		CommonModule,
		VirtualScrollerModule,
		TooltipModule.forRoot(defaultTooltipOptions as TooltipOptions),
		ClickOutsideModule,
		UpgradeModule,
		RestangularModule.forRoot(RestangularConfigFactory),
		HttpClientModule,
		NgApexchartsModule,
		ClipboardModule,
		ngfModule,
		AngularMyDatePickerModule,
		NgxSummernoteModule,
		DragDropModule,
		AppRoutingModule,
		ColorPickerModule,
		NgProgressModule,
		PdfViewerModule,
		NgxDocViewerModule,
		NgxUploaderModule,
		NgOptimizedImage
	],
	providers: [
		RouteService,
		NotificationService,
		UserPermissionService,
		GeneralService,
		LookAndFeelService,
		AuthService,
		QuickAccessService,
		AccountCompromisedService,
		ArchiveService,
		ClioService,
		ComposeMessageService,
		DropboxService,
		myEmailsService,
		InboundTrendsService,
		TableQueryTemplatesService,

		// for loading bar
		importProvidersFrom(NgProgressHttpModule),
		provideHttpClient(withInterceptorsFromDi()),
	],
	bootstrap: [AppComponent]
})
export class AppModule {
	constructor() {
	}
}
